import { useState } from "react"
import {
  Card,
  Typography,
  Divider,
  IconButton,
  BottomNavigation,
  BottomNavigationAction,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import {
  calc_card_stats,
  calc_card_facilities,
  calc_card_demographics,
} from "../../utils/functions"
import DiseaseInfo from "./DiseaseComponents/MainDisease"
import MainStats from "./StatsComponents/Main"
import Demographics from "./Demographics/Main"

export default function MainStatsCard({
  current_id,
  mode,
  map_data,
  dispatch_ui,
}) {
  const [tab_selection, set_tab_selection] = useState(0)
  const {
    cup_geo_json,
    cup_boundary_geo_json,
    fac_geo_json,
    au_geo_json,
    district_geo_json,
  } = map_data

  const current_stats = calc_card_stats(au_geo_json, mode, current_id)
  if (!current_stats) {
    return null
  }

  const demographic_stats = calc_card_demographics(
    au_geo_json,
    mode,
    current_id,
  )
  if (!demographic_stats) {
    return null
  }

  const card_facilities = calc_card_facilities({
    fac_geo_json,
    district_geo_json,
    cup_boundary_geo_json,
    mode,
    current_id,
  })
  if (!card_facilities) {
    return null
  }

  return (
    <Card
      style={{
        width: 530,
        height: mode === "districts" ? 371 : 371,
        position: "absolute",
        right: 10,
        top: mode === "districts" ? 465 : 70,
        padding: 10,
        overflowY: "auto",
        zIndex: 1000,
      }}
    >
      <IconButton
        style={{ right: 5, position: "absolute", top: 5 }}
        onClick={() => {
          dispatch_ui({
            type: mode === "districts" ? "SET_VIEW_DISTRICT" : "SET_VIEW_CUP",
            payload: { id: null },
          })
        }}
      >
        <CloseIcon />
      </IconButton>
      <Typography variant="h6">
        {mode === "districts"
          ? `District Name: ${
              map_data.district_geo_json.features.find(
                (municipality) => municipality.id === current_id,
              ).properties.name
            }`
          : `CUP Name: ${
              cup_geo_json.features.find((cup) => cup.id === current_id)
                .properties.name
            }`}
      </Typography>
      <Divider style={{ marginBottom: 10 }} />
      {tab_selection === 0 && (
        <MainStats
          mode={mode}
          current_stats={current_stats}
          card_facilities={card_facilities}
          cup_geo_json={cup_geo_json}
          current_id={current_id}
          fac_geo_json={fac_geo_json}
        />
      )}
      {tab_selection === 1 && (
        <DiseaseInfo au_geo_json={au_geo_json} mode={mode} id={current_id} />
      )}
      {tab_selection === 2 && <Demographics stats={demographic_stats} />}
      <BottomNavigation
        value={tab_selection}
        onChange={(event, newValue) => set_tab_selection(newValue)}
        showLabels
        style={{
          height: 25,
          width: "100%",
          position: "absolute",
          bottom: 7,
          borderTop: "1px solid #ECEEF0",
        }}
      >
        <BottomNavigationAction
          label="Statistics"
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#ECEEF0",
              color: "black",
            },
          }}
        />
        <BottomNavigationAction
          label="Disease Burden"
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#ECEEF0",
              color: "black",
            },
          }}
        />
        <BottomNavigationAction
          label="Demographics"
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#ECEEF0",
              color: "black",
            },
          }}
        />
      </BottomNavigation>
    </Card>
  )
}
